"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NFTExchangeTransactionBuilder = void 0;
const crypto_1 = require("@arkecosystem/crypto");
const enums_1 = require("../enums");
class NFTExchangeTransactionBuilder extends crypto_1.Transactions.TransactionBuilder {
    constructor() {
        super();
        this.data.version = enums_1.NFTExchangeTransactionVersion;
        this.data.typeGroup = enums_1.NFTExchangeTransactionsTypeGroup;
        this.data.amount = crypto_1.Utils.BigNumber.ZERO;
    }
    getStruct() {
        const struct = super.getStruct();
        struct.amount = this.data.amount;
        struct.asset = this.data.asset;
        struct.vendorField = this.data.vendorField;
        return struct;
    }
}
exports.NFTExchangeTransactionBuilder = NFTExchangeTransactionBuilder;
//# sourceMappingURL=nft-exchange-builder.js.map